<app-card-widget [title]="'Client' + (data.client?.company_situation ? ' ⚠️' : '')" subtitle="{{data.client?.name}}" *ngIf="clientAndRepresentative$ | async as data">

  <form [formGroup]="form" id="client-form" (ngSubmit)="save(data.client, data.representative)" *ngIf="countries$ | async as countries" novalidate>

    <div class="card-section-container">
      <div class="card-section" formGroupName="client">

        <app-text label="Name" *ngIf="!edited">
            <a [routerLink]="['/clients/', data.client.id]">{{data.client.name}}</a>
        </app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Name" formControlName="name" />
        </mat-form-field>

        <app-text label="Country" *ngIf="!edited">{{countries.get(data.client.country)?.name}}</app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Country" formControlName="country">
            <mat-option *ngFor="let option of countries.all()" [value]="option.code">
              {{option.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Business ID" *ngIf="!edited">{{data.client.business_id}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Business ID" formControlName="business_id" />
        </mat-form-field>

        <app-company-form-fields [formGroup]="form.get('client')" [entity]="data.client" [editMode]="edited"></app-company-form-fields>

        <app-text label="Company Situation" *ngIf="!edited">
          <ng-container *ngIf="data.client.company_situation; else noSituation">
            {{data.client.company_situation}} <mat-icon color="warn" style="vertical-align: text-bottom;">warning</mat-icon>
          </ng-container>
          <ng-template #noSituation>-</ng-template>
        </app-text>

        <app-text label="Created" *ngIf="!edited">{{ data.client.created_at | date }}</app-text>

        <app-text label="Prepayment Register Checked" *ngIf="!edited">{{ (data.client.prepayment_register?.checked_at | date:'shortDate') || 'Never' }}</app-text>

        <app-text label="In Prepayment Register" *ngIf="!edited">
          <ng-container [ngSwitch]="data.client.prepayment_register?.is_in_register">
              <span *ngSwitchCase="true">Yes</span>
              <span *ngSwitchCase="false">No</span>
              <span *ngSwitchDefault>-</span>
          </ng-container>
        </app-text>

        <mat-checkbox *ngIf="edited" class="wrapping-checkbox" formControlName="mark_prepayment_register_checked">Update Prepayment Register Status</mat-checkbox>

        <mat-checkbox *ngIf="edited" class="wrapping-checkbox" formControlName="is_in_prepayment_register">In Prepayment Register</mat-checkbox>

      </div>
      <div class="card-section" formGroupName="representative">

        <app-text label="First Name" *ngIf="!edited">{{data.representative.first_name}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="First Name" formControlName="first_name" />
        </mat-form-field>

        <app-text label="Last Name" *ngIf="!edited">{{data.representative.last_name}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Last Name" formControlName="last_name" />
        </mat-form-field>

        <app-text label="SSN">{{data.representative.masked_ssn}}</app-text>

        <app-text label="Email" *ngIf="!edited">{{data.representative.email}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Email" type="email" formControlName="email" />
        </mat-form-field>

        <app-text label="Phone" *ngIf="!edited">{{data.representative.phone}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Phone" formControlName="phone" />
        </mat-form-field>

      </div>
      <div class="card-section" formGroupName="client">
        <app-text *ngIf="!edited" label="Client Lead Source">
          {{data.client.lead_source?.name}}
          <mat-icon *ngIf="data.client.lead_source?.id !== data.invoice.lead_source?.id"
                    matTooltip="Differs from invoice value"
                    class="mat-icon-sm"
                    color="warn">warning</mat-icon>
        </app-text>

        <app-text *ngIf="!edited" label="Client Responsible Seller">
          {{data.client.responsible_seller?.name}}
          <mat-icon *ngIf="data.client.responsible_seller?.id !== data.invoice.responsible_seller?.id"
                    matTooltip="Differs from invoice value"
                    class="mat-icon-sm"
                    color="warn">warning</mat-icon>
        </app-text>

        <app-text label="Credit Limit">{{ data.client.credit_limit?.limit.amount | currency: 'EUR' }}</app-text>
        <app-text label="Credit Limit Updated">{{ (data.client.credit_limit?.checked_at | date:'shortDate') || 'Never' }}</app-text>

        <app-text label="Credit Rating" *ngIf="!edited">{{ data.client.aaa_rating?.category }}</app-text>
        <mat-form-field *ngIf="edited" formGroupName="aaa_rating">
          <mat-select placeholder="Rating" formControlName="category">
            <mat-option *ngFor="let rating of aaaRatings" [value]="rating">
              {{rating}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Credit Rating Updated">{{ (data.client.aaa_rating?.checked_at | date:'shortDate') || 'Never'}}
        </app-text>

        <app-text *ngIf="!edited && (data.client.credit_limit?.checked_at || data.client.aaa_rating?.checked_at)" label="Update Credit Limit And Rating">Mark checked
          <app-hold-to-confirm-button (confirmed)="touchCreditLimitAndRating(data.client)" title="Hold to update timestamp"></app-hold-to-confirm-button>
        </app-text>

      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked" (click)="edit(data.client, data.representative)">Edit</button>
    <button type="submit" mat-button *ngIf="edited" [disabled]="!form.valid" form="client-form">Save</button>
    <button type="reset" mat-button *ngIf="edited" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>
